import type { Opportunity } from "@entities";

/** Fields copied from parent to a new group child slot (explicit whitelist). */
export const GROUP_CHILD_COPIED_FIELD_NAMES = [
  "title",
  "description",
  "imageId",
  "requestImageId",
  "organizationId",
  "partnerOrganizationId",
  "managerId",
  "associationRequestedId",
  "aidRequestFormId",
  "subCategoryId",
  "location",
  "coordinates",
  "destination",
  "destinationCoordinates",
  "day",
  "timeDescription",
  "comments",
  "whatsappGroupUrl",
  "defaultMatchWeight",
  "minAge",
  "maxAge",
  "requiredGender",
  "contactDetails",
  "notificationTemplates",
  "postRegistrationContent",
  "preRegistrationProcessText",
  "registrationButtonText",
  "status",
  "managerUrgency",
  "isPublic",
  "isReportRequired",
  "isValidationRequired",
  "volunteerMode",
  "isLongTerm",
  "hasTime",
  "hasStartTime",
  "requiresVehicle",
  "isSensitive",
  "isRemote",
  "isSendAssociationAidMessage",
  "isSendParticipantReminder",
  "volunteerRegistrationFlow",
  "targetOrganizationName",
] as const satisfies readonly (keyof Opportunity)[];

export function pickGroupChildBaseFields(
  parent: Opportunity,
): Partial<Opportunity> {
  const picked: Partial<Opportunity> = {};
  for (const key of GROUP_CHILD_COPIED_FIELD_NAMES) {
    const v = parent[key as keyof Opportunity];
    if (v !== undefined) {
      (picked as Record<string, unknown>)[key] = v;
    }
  }
  return picked;
}
